import React from 'react';

import isEqual from 'lodash/isEqual';

import { useSlateSelector } from '@lumapps/wrex/slate';

import { useRefineContentDialog } from '../../hooks/useRefineContentDialog';
import { RefineContentDialog } from '../RefineContentDialog';
import { RefineContentMenu } from '../RefineContentMenu';

export interface RefineContentButtonProps {
    editorRef: React.RefObject<HTMLDivElement>;
}

export const RefineContentButton: React.FC<RefineContentButtonProps> = ({ editorRef }) => {
    const buttonRef = React.useRef(null);

    const {
        refinementHistory,
        isRefiningContent,
        isPopoverOpen,
        onRefineContent,
        onInsertNewContent,
        onCancelRefinement,
    } = useRefineContentDialog();

    const isSelectionActive = useSlateSelector(
        (editor) => Boolean(editor.selection) && !isEqual(editor.selection?.anchor, editor.selection?.focus),
    );

    return isSelectionActive || isPopoverOpen ? (
        <>
            <RefineContentMenu buttonRef={buttonRef} onRefineContent={onRefineContent} isPopoverOpen={isPopoverOpen} />

            {isPopoverOpen && (
                <RefineContentDialog
                    anchorRef={buttonRef}
                    editorRef={editorRef}
                    isRefiningContent={isRefiningContent}
                    refinementHistory={refinementHistory}
                    onCancelRefinement={onCancelRefinement}
                    onInsertNewContent={onInsertNewContent}
                    onRefineContent={onRefineContent}
                />
            )}
        </>
    ) : null;
};
